var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlignLeftFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    width: "100%",
    height: "100%",
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.9941 39.9951V215.995C47.9941 220.413 44.4124 223.995 39.9941 223.995C35.5759 223.995 31.9941 220.413 31.9941 215.995V39.9951C31.9941 35.5768 35.5759 31.9951 39.9941 31.9951C44.4124 31.9951 47.9941 35.5768 47.9941 39.9951ZM80 120H176C184.837 120 192 112.837 192 104V64C192 55.1634 184.837 48 176 48H80C71.1634 48 64 55.1634 64 64V104C64 112.837 71.1634 120 80 120ZM216 136H80C71.1634 136 64 143.163 64 152V192C64 200.837 71.1634 208 80 208H216C224.837 208 232 200.837 232 192V152C232 143.163 224.837 136 216 136Z",
    fill: "var(--fill-0, #5D7285)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignLeftFill);
export default __webpack_public_path__ + "static/media/align-left-fill.3851c5fae1fe0be084bce4078d7dcc15.svg";
export { ForwardRef as ReactComponent };